import { createSlice } from "@reduxjs/toolkit";
import { onlineOfflineDevice } from "../../actions/controlPanel/onlineOfflineDevice";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const onlineOfflineDeviceReducer = createSlice({
  name: "onlineOfflineDevice",
  initialState,
  reducers: {
    // cleargetOnlineOfflineDevice: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(onlineOfflineDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(onlineOfflineDevice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(onlineOfflineDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// export const { cleargetOnlineOfflineDevice } = getCategoriessSlice.actions;
export default onlineOfflineDeviceReducer.reducer;
